module.exports = __webpack_public_path__ + "assets/img/modal-avatar-29670d89.png";